import { FieldGroup, TextBox } from '@idexx-laboratories/spot-react';
import { runInAction } from 'mobx';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import { useStore } from '../../hooks/use-store';

const AddSapContent = observer(() => {
  const { usersManagementStore: store, globalStore } = useStore();

  const [sapId, setSapId] = useState('');

  const [error, setError] = useState('');

  const modalProps = globalStore.globalModalProps;

  const verifyAndApply = useCallback(() => {
    if (!/^\d{4,6}$/.test(sapId)) {
      setError('Enter a valid SAP ID');
    } else if (Object.keys(store.currentUser.sapRoleIndices || {}).some(s => s === sapId)) {
      setError('SAP ID already exists');
    } else {
      store.addSap(sapId);
      modalProps.show = false;
    }
  }, [modalProps, sapId, store]);

  const onChange = (value: string): void => {
    if (/^\d{0,6}$/.test(value)) {
      setSapId(value);
      setError('');
    }
  };

  useEffect(() => {
    runInAction(() => {
      modalProps.exitOkAction = false;
      modalProps.onOk = () => verifyAndApply();
    });
  }, [modalProps, verifyAndApply]);

  return (
    <FieldGroup errorText={error}>
      <TextBox
        className='add-sapid-input'
        placeholder='Enter SAP ID and click Submit'
        data-testid='add-sapid-input'
        disabled={modalProps.disabled}
        value={sapId}
        onChange={e => onChange(e.target.value)}
      />
    </FieldGroup>
  );
});

export default AddSapContent;
